import { useEffect, useState } from 'react';

import useCopy from '@collab/hooks/useCopy';

/**
 * Tries to copy a value the moment it gets available.
 * Useful for example lazy loaded values.
 */
const useCopyDelayed = (secret: string | undefined) => {
  const { copied, copyError, onCopy } = useCopy();
  const [awaitCopy, setAwaitCopy] = useState(false);

  useEffect(() => {
    if (secret && awaitCopy) {
      onCopy(secret);
      setAwaitCopy(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secret]);

  const copySecret = () => {
    if (secret) {
      onCopy(secret);
    } else {
      setAwaitCopy(true);
    }
  };

  return {
    isLoading: awaitCopy,
    copied,
    copyError,
    copySecret,
  };
};

export default useCopyDelayed;
